import { OrderStatus } from '@blisspointmedia/bpm-types/dist/LinearBuying';
import { PendingAgentOrder } from './agent-order-approval-constants';

// Typed `number` because order.status is a plain number off the API.
const DRAFT_STATUS: number = OrderStatus.PENDING;
const COMMITTED_STATUS: number = OrderStatus.CONFIRMED;
const CANCELED_STATUS: number = OrderStatus.CANCELED;

// A person approved it: a draft with a recorded approval, or an order committed to status 20
// before approvals were recorded.
export const isApprovedAgentOrder = ({ status, approved_at }: PendingAgentOrder): boolean =>
  status === COMMITTED_STATUS || (status === DRAFT_STATUS && Boolean(approved_at));

// Sendable: a draft with a recorded approval. One committed before approvals were recorded has no
// approval for the send to copy, so bpm-lambdas refuses to make its IO.
export const canSendAgentOrder = ({ status, approved_at }: PendingAgentOrder): boolean =>
  status === DRAFT_STATUS && Boolean(approved_at);

export const agentOrderStatusLabel = (order: PendingAgentOrder): string => {
  if (isApprovedAgentOrder(order)) return 'Approved — awaiting send';
  if (order.status === DRAFT_STATUS) return 'Draft';
  if (order.status === CANCELED_STATUS) return 'Cancelled — rolled back';
  return `Status ${order.status}`;
};
